import { getSafeSupabaseClient } from '../supabaseSync';
import { unwrapRpcResult } from './rpcEnvelope';

export interface CancelInquiryArgs {
  inquiryId: string;
  actorId: string;
  actorName?: string | null;
  rationale?: string | null;
}

export interface CancelInquiryResult {
  success: boolean;
  inquiry_id: string;
  loop_id: string;
  status: 'CANCELLED';
}

/**
 * Cancel an inquiry.
 * 
 * Atomic transaction:
 * - Updates inquiry status to CANCELLED
 * - Emits governance event (inquiry_cancelled)
 */
export async function cancelInquiry(args: CancelInquiryArgs): Promise<CancelInquiryResult> {
  const supabase = getSafeSupabaseClient();
  if (!supabase) {
    throw new Error('Supabase client not available');
  }

  const { data, error } = await supabase.rpc('catchball_cancel_inquiry', {
    p_inquiry_id: args.inquiryId,
    p_actor_id: args.actorId,
    p_actor_name: args.actorName ?? null,
    p_rationale: args.rationale ?? null,
  });

  // Refusals arrive either as a PostgREST error or as { success: false, error }.
  return unwrapRpcResult<CancelInquiryResult>(data, error, 'The server refused the withdrawal.');
}
